function dateToIsoFormat(date) {
	// date is expected in YYYY-MM-DD format
	const dateObj = new Date(date);

	return dateObj.toISOString();
}

export default dateToIsoFormat;
